import { Form, Input } from "antd";
import type { LowValuePurchaseRequisitionFormValue } from "../../type";
import { PricePopup } from "./PricePopup";

interface PriceCellProps {
  fieldName: number;
  editingIndex: number | null;
  pricePopupOpen: boolean;
  onOpenEdit: (index: number) => void;
  onClose: () => void;
  onSave: (values: {
    price: number;
    priceUnit: string;
    priceHkd: number;
  }) => void;
  disabled: boolean;
}

export const PriceCell = ({
  fieldName,
  editingIndex,
  pricePopupOpen,
  onOpenEdit,
  onClose,
  onSave,
  disabled,
}: PriceCellProps) => {
  const form = Form.useFormInstance<LowValuePurchaseRequisitionFormValue>();
  const itemPriceHkd = Form.useWatch(["itemList", fieldName, "priceHkd"], form);

  return (
    <PricePopup
      open={editingIndex === fieldName && pricePopupOpen}
      onClose={onClose}
      onSave={onSave}
      initialValues={{ priceHkd: itemPriceHkd }}
    >
      <Input
        disabled={disabled}
        placeholder="请输入"
        readOnly
        value={itemPriceHkd ? `${itemPriceHkd}` : ""}
        onClick={() => onOpenEdit(fieldName)}
        style={{ cursor: "pointer" }}
      />
    </PricePopup>
  );
};
